import loadComponentSponsors from './components/ModalSponsors';
import loadComponentTriggerSponsors from './components/TriggerSponsors';
import loadComponentBirthday from './components/Birthday';
import loadComponentModalLockRecord from './components/ModalLockRecord';

import loadExtendComponentCard from './components/Card';
import loadExtendComponentForm from './components/Form';
import loadExtendComponentLabel from './components/Label';
import loadExtendComponentInput from './components/Input';
import loadExtendComponentLink from './components/Link';


import loadComponentFormLayers from './components/FormLayers';
import loadComponentLayer from './components/Layer';
import loadComponentSelect from './components/Select';
import loadComponentRadio from './components/Radio';
import loadComponentCustomSelect from './components/CustomSelect';
import loadComponentSelectDay from './components/SelectDay';
import loadComponentSelectMonth from './components/SelectMonth';
import loadComponentSelectYear from './components/SelectYear';

import loadComponentGenderSelect from './components/GenderSelect';
import loadComponentGenderRadio from './components/GenderRadio';
import loadComponentGender from './components/Gender';

import loadComponentSwitch from './components/Switch';
import loadComponentAccordionPrivacy from './components/AccordionPrivacy';
import loadComponentProgressBarBySteps from './components/ProgressBarBySteps';
import loadComponentProgressBarPercent from './components/ProgressBarPercent';
import loadComponentAcceptanceTerms from './components/AcceptanceTerms';


import loadComponentQuestionOption from './components/QuestionOption';

import loadComponentQuestion from './components/Question';
import loadComponentQuestionOptions from './components/QuestionOptions';
import loadComponentContainerCoregistro from './components/ContainerCoregistro';
import loadComponentApplicationCoregistrationRequestButton from './components/ApplicationCoregistrationRequestButton';
import loadComponentApplicationCoregistration from './components/ApplicationCoregistration';
import loadComponentRadioGroup from './components/RadioGroup';
import loadComponentSelectOptions from './components/SelectOptions';
import loadComponentQuestionText from './components/QuestionText';


import loadComponentFormSwiper from './components/FormSwiper';
import loadComponentFormSwiperWrapper from './components/FormSwiperWrapper';
import loadComponentFormSwiperSlider from './components/FormSwiperSlide';

import loadComponentContainerConditional from './components/ContainerConditional';
import loadComponentWrongAddressMessage from './components/WrongAddressMessage';
import loadComponentGoogleMapsAddress from './components/GoogleMapsAddress';
import loadComponentDNI from './components/DNI';
import loadComponentLicensePlate from './components/LicensePlate';
import loadComponentFormRow from './components/FormRow';
import loadComponentInvalidFeedback from './components/InvalidFeedback';


export default (editor, opts = {}) => {
    
    loadComponentSponsors(editor, opts);
    loadComponentTriggerSponsors(editor, opts);
    loadComponentModalLockRecord(editor, opts);

    

    /* Single components */
    loadComponentSelect(editor,opts);
    loadComponentRadio(editor,opts);
    loadComponentCustomSelect(editor,opts);
    loadComponentSelectDay(editor,opts);
    loadComponentSelectMonth(editor,opts);
    loadComponentSelectYear(editor,opts);
    loadComponentFormLayers(editor,opts);
    loadComponentLayer(editor,opts);
    loadComponentGenderSelect(editor,opts);
    loadComponentGenderRadio(editor,opts);
    loadComponentGender(editor,opts);
    loadComponentSwitch(editor,opts);
    loadComponentAccordionPrivacy(editor,opts);
    loadComponentProgressBarBySteps(editor,opts);
    loadComponentProgressBarPercent(editor,opts);
    loadComponentAcceptanceTerms(editor,opts);


    /* Extend components */

    loadExtendComponentCard(editor,opts);
    loadExtendComponentForm(editor,opts);
    loadExtendComponentLabel(editor,opts);
    loadExtendComponentInput(editor,opts);
    loadExtendComponentLink(editor,opts);


    /* Advance componentes*/
    loadComponentBirthday(editor,opts);
    
    /* Question components */
    loadComponentQuestionOption(editor,opts);

    loadComponentQuestionText(editor,opts);
    loadComponentRadioGroup(editor,opts);
    loadComponentSelectOptions(editor,opts);
    loadComponentQuestion(editor,opts);
    loadComponentQuestionOptions(editor,opts);
    loadComponentContainerCoregistro(editor,opts);
    loadComponentApplicationCoregistrationRequestButton(editor,opts);
    loadComponentApplicationCoregistration(editor,opts);

    /** Form Swiper */
    loadComponentFormSwiper(editor,opts);
    loadComponentFormSwiperWrapper(editor,opts);
    loadComponentFormSwiperSlider(editor,opts);


    loadComponentContainerConditional(editor,opts);
    loadComponentFormRow(editor,opts);
    loadComponentInvalidFeedback(editor,opts);
    loadComponentGoogleMapsAddress(editor,opts);
    loadComponentDNI(editor,opts);
    loadComponentLicensePlate(editor,opts);
    loadComponentWrongAddressMessage(editor,opts);
};
